import { useQuery } from '@tanstack/react-query';

import api from 'api';
import type { Agent } from 'types';

/** Agents and agreements both load this list for a service provider. */
export const ORGANIZATION_AGENT_STALE_MS = 5 * 60 * 1000;

export const organizationAgentKeys = {
    all: ['organizationAgents'] as const,
    byServiceProvider: (serviceProviderId: string) =>
        ['organizationAgents', serviceProviderId] as const,
};

export const organizationAgentListQuery = (serviceProviderId: string) => ({
    queryKey: organizationAgentKeys.byServiceProvider(serviceProviderId),
    queryFn: async (): Promise<Agent[]> => {
        const response = await api.clientServiceProviders.getOrganizationAgents(serviceProviderId);
        return (response.data ?? []) as Agent[];
    },
    staleTime: ORGANIZATION_AGENT_STALE_MS,
    retry: false,
});

export interface UseOrganizationAgentsOptions {
    enabled?: boolean;
}

/**
 * GET /client-service-providers/:id/agents
 * Shared by the agents page and the agreement form.
 */
export const useOrganizationAgents = (
    serviceProviderId?: string | null,
    options?: UseOrganizationAgentsOptions
) => {
    const id = serviceProviderId ?? '';

    return useQuery({
        ...organizationAgentListQuery(id),
        enabled: (options?.enabled ?? true) && Boolean(id),
    });
};
